export default __webpack_public_path__ + "static/media/errorv2.3ffa9c87.svg";